import { render, staticRenderFns } from "./LotSellers.vue?vue&type=template&id=ae4c40f4"
import script from "./LotSellers.vue?vue&type=script&lang=ts"
export * from "./LotSellers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./lotSeller.fr.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc2173210599%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Flot-seller%2FLotSellers.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./lotSeller.en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc2173210599%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Flot-seller%2FLotSellers.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports